const config = {
    BACKEND_URL: 'https://shelter-api.neken.com.ua',
    // BACKEND_URL: 'http://91.107.193.141',
    // BACKEND_URL: 'http://localhost:3001',
}

export default config;